var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuiconWhitelabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16559 3.33594L9.16543 11.6695H8.33211V13.3361H9.16543L9.16562 16.6693H10.8323L10.8321 13.3361H11.6654V11.6695H10.8321L10.8323 3.33594H9.16559ZM4.16535 3.33594V6.67012H3.33203V8.33594H4.16535V16.6693H5.83203V8.33594H6.66535V6.67012H5.83203V3.33594H4.16535ZM14.1646 3.33609V8.33609H13.3313L13.3318 10.0026H14.1651V16.6693H15.8326V10.0026H16.6659L16.6654 8.33609H15.8321L15.8326 3.33594L14.1646 3.33609Z",
    fill: "#304674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuiconWhitelabel);
export default __webpack_public_path__ + "static/media/menuicon-whitelabel.6922dc3afb42a305e10e3a1fbd1167b5.svg";
export { ForwardRef as ReactComponent };